import website from '../assets/website.png'
import instagram from '../assets/instagram.png'
import linkedin from '../assets/linkedin.jpg'
import youtube from '../assets/youtube.jpeg'
// import dribbble from '../assets/dribbble.png'
import github from '../assets/github.png'
import telegram from '../assets/telegram.png'
import twitter from '../assets/twitter.png'
import tape from '../assets/tape.jpg'
import soundcloud from '../assets/soundcloud.jpeg'
import bandlab from '../assets/open-graph-4fd21aa09f.png'

const items = [{
    "title": "Website",
    "subtitle": "Professional Realm",
    "image": website,
    "link": "https://dishant.me" //your personal website or portfolio  link
},
{
    "title": "Bandlab",
    "subtitle": "My Bandlab Profile",
    "image": bandlab,
    "link": "https://www.bandlab.com/dishantpandya"
},

{
    "title": "SoundCloud",
    "subtitle": "My SloundCloud Profile",
    "image": soundcloud,
    "link": "https://soundcloud.com/dishant-pandya"
},
{
    "title": "Artist Portfolio",
    "subtitle": "Me in Alternate Universe of Music",
    "image": tape,
    "link": "https://music.dishantpandya.com"
},
{
    "title": "GitHub",
    "subtitle": "@drpdishant | 🏡 to all my open-source projects",
    "image": github,
    "link": "https://github.com/drpdishant" //Github Profile link
},
{
    "title": "Instagram",
    "subtitle": "@dishant_pandya |  Shots of my life 🙂",
    "image": instagram,
    "link": "https://instagram.com/dishant_pandya" //instagram profile link 
},
{
    "title": "Twitter",
    "subtitle": "@dishantpandya | 😉",
    "image": twitter,
    "link": "https://twitter.com/dishantpandya"// twitter profile link 
},
{
    "title": "LinkedIn",
    "subtitle": "Know more about my profession 👨‍💼",
    "image": linkedin,
    "link": "https://www.linkedin.com/in/dishant-pandya-a58110139" // linkedin
},
{
    "title": "YouTube",
    "subtitle": "Dishant Pandya | Realm of music",
    "image": youtube,
    "link": "https://www.youtube.com/c/DishantPandya/"//youtube channel link 
},
{
    "title": "Telegram",
    "subtitle": "@dishantpandya | Chat with me instantly ",
    "image": telegram,
    "link": "https://telegram.me/dishantpandya" //Telegram Pofile 
}]

export default items
